import { useLang } from "@/lib/lang";

export default function Marquee() {
  const { t } = useLang();
  const loop = [...t.marquee, ...t.marquee];
  return (
    <section className="marquee" data-testid="marquee">
      <div className="marquee-track">
        {loop.map((item, i) => (
          <span key={i} style={{ display: "inline-flex", gap: 48, alignItems: "center" }}>
            <span className="marquee-item">{item}</span>
            <span className="marquee-dot">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
